import Upload, { getMimeType, image } from '@/pages/globalpedia/components/Upload';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import SlidebarVideo from '@gp/components/SlidebarVideo';
import { useUpdateEffect } from 'ahooks';
import classnames from 'classnames';
import React, { useMemo, useState } from 'react';
import { Button, Col, List, Row, message } from 'tea-component';
import { UPLOAD_FOLDER_NAME_MAP } from '@gp/constants/const';
import './index.scss';

const COVER_MIN_WIDTH = 960;
const COVER_MIN_HEIGHT = 600;
const ACCEPTS = [...(image?.split(',') || [])];

export default function CoverBox(props: any) {
  const {
    resource_cover,
    cover_list,
    handleOnUploadCover,
    handleChangeModalCancel,
    setDisabledBtn,
    setDisabledBtnFalse,
    isDisabledBtn,
  } = props;

  const defaultCover = useMemo(() => {
    if (resource_cover) return resource_cover;
    if (Array.isArray(cover_list) && cover_list?.length > 0) return cover_list[0];
    return '';
  }, [resource_cover, cover_list]);

  // 默认图片高亮
  const [isDefaultActive, setDefaultIsActive] = useState(defaultCover);
  // 默认大图
  const [isDefaultCoverOneImg, setIsDefaultCoverOneImg] = useState(defaultCover);
  // 勾选替换封面
  const [changeCover, setChangeCover] = useState('');
  const handleOnSubmit = () => {
    handleOnUploadCover(changeCover || isDefaultActive, !!changeCover);
    handleChangeModalCancel?.();
  };
  // 这个为了兼容旧风格，调接口，忽略首次执行，当异步加载完成，这里重置第一项为高亮项
  useUpdateEffect(() => {
    if (cover_list.includes(resource_cover)) {
      setDefaultIsActive(cover_list[0]);
      setIsDefaultCoverOneImg(cover_list[0]);
    }
  }, [cover_list]);

  return (
    <div className="dialog-cover-box">
      <div className="dialog-cover-box-hd">
        <h3 className="dialog-cover-box-title">Cover</h3>
        <Button
          icon="close"
          className="dialog-cover-button-close"
          onClick={handleChangeModalCancel}
        />
        <div className="dialog-cover-button-add">
          <Upload
            type={'image'}
            id="cover"
            minWidth={COVER_MIN_WIDTH}
            uploadFolderName={UPLOAD_FOLDER_NAME_MAP.image}
            minHeight={COVER_MIN_HEIGHT}
            accept={ACCEPTS}
            getMimeType={getMimeType}
            onStart={setDisabledBtn}
            onSuccess={(status, result, path) => {
              setIsDefaultCoverOneImg(result?.url);
              setChangeCover(result?.url);
              setDisabledBtnFalse();
            }}
            onError={(error) => {
              setDisabledBtnFalse();
            }}
            onWidthOrHeightLess={() => {
              setDisabledBtnFalse();
              message.error({
                content: `Cover size not less than ${COVER_MIN_WIDTH} x ${COVER_MIN_HEIGHT}`,
              });
            }}
            slot={<Button type="link">Add Cover</Button>}
          />
        </div>
      </div>
      <div className="dialog-cover-body">
        <div className="visual-album">
          {/* 大图 */}
          <Row className="visual-album-show">
            <Col span={24} className="visual-album-show-box">
              <div className="navigation-img" style={{ height: '100%' }}>
                <img src={isDefaultCoverOneImg} alt="" />
              </div>
            </Col>
          </Row>
          <div className="visual-album-tips">Please select a video cover</div>
          {/* 小图列表 */}
          <SlidebarVideo
            listNodeClassName="visual-album__body-visual-list"
            className="visual-album__body_visual_thumbnail-slidebar dbg-visual-slidebar-div"
          >
            <List className="visual-album__body-visual-list">
              {cover_list?.map((task: string, taskIndex: React.Key | null | undefined) => (
                <List.Item
                  key={taskIndex}
                  className={classnames('visual-album__body-visual-list-item', {
                    'is-active': isDefaultActive === task,
                  })}
                >
                  <div
                    className="item-img-box"
                    onClick={() => {
                      setDefaultIsActive(task);
                      setIsDefaultCoverOneImg(task);
                    }}
                  >
                    <GeneralImageNew src={task} width={56} height={36} errorImg="" />
                  </div>
                </List.Item>
              ))}
            </List>
          </SlidebarVideo>
        </div>
      </div>
      <div className="dialog-cover-footer">
        <Button type="primary" onClick={handleOnSubmit} disabled={isDisabledBtn}>
          Confirm
        </Button>
        <Button type="weak" onClick={handleChangeModalCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
